import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { TileViewComponent } from './tile-view.component';

@NgModule({
   declarations: [TileViewComponent],
   imports: [
      CommonModule,
      DialogModule,
      MatIconModule,
      MatTooltipModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatTabsModule,
   ],
   exports: [TileViewComponent],
})
export class TileViewModule {}
